import { Component, input, Input } from '@angular/core';
import { AvatarModule } from 'primeng/avatar';
import { AvatarGroupModule } from 'primeng/avatargroup';
import { InitialsPipe } from '../../../_pipes/initials.pipe';
import { People } from '../../../models/people';


@Component({
  selector: 'app-avatar',
  standalone: true,
  imports: [AvatarModule, AvatarGroupModule, InitialsPipe],
  templateUrl: './avatar.component.html',
  styleUrl: './avatar.component.scss'
})
// This componenent warp the avatar module from PrimeNG to fallback on initials if no avatar is configured
export class AvatarComponent {
  //convert the input to an array of People
  // This allows to use the component with a single person or an array of people
  @Input() set personOrPeople(value: People | People[]) {
    if (Array.isArray(value)) {
      this.people = value;
    } else if (value) { // Assurez-vous que ce n'est pas null/undefined
      this.people = [value]; // Transforme la personne unique en tableau
    } else {
      this.people = []; // Si null ou undefined, un tableau vide
    }
  }
  @Input() size: 'normal' | 'large' | 'xlarge' = 'normal';
  @Input() shape: 'circle' | 'square' = "circle";
  @Input() class: string = '';
  @Input() groupCLass: string = ''; 
  @Input() grouped: boolean = false;

  //this is the array of people to display
  people: People[] = [];
}
